import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { ComboService } from '../Model/Combo/combo.service';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { FormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import { CommonService } from '../Model/Common/common.service';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { NgbActiveModal, NgbCollapse } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-employee-filter',
  standalone: true,
  imports: [CommonModule, NgSelectModule, DataTablesModule, FormsModule, LoaderComponent, NgbCollapse],
  templateUrl: './employee-filter.component.html',
  styleUrl: './employee-filter.component.scss'
})
export class EmployeeFilterComponent {

  Branchs: any[] = []
  Clients: any[] = []
  Sites: any[] = []
  TableDatas: any[] = []
  isDisabled: boolean = false;
  isCollapsed: boolean = false;

  Filter = {
    BranchId: null,
    ClientId: null,
    SiteId: null,
    EmpCode: '',
    EmpName: ''
  }

  dtoptions: DataTables.Settings = {
      pagingType: 'full_numbers',
      searching: true,
      pageLength: 5,
      lengthMenu: [5, 10, 25, 50, 100],
      processing: true,
      lengthChange: true,
      language: {
        searchPlaceholder: 'Search...',
      }
    };

  constructor(
    private comboload: ComboService,
    private toast: ToastService,
    public common: CommonService,
    private activeModal: NgbActiveModal
  ) { }

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  ngOnInit() {
    this.ComboLoad('Branch');
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    if (Combotype == 'Site') {
      this.Filter.SiteId = null;
      this.Sites = [];
    } else if (Combotype == 'Client') {
      this.Filter.ClientId = null;
      this.Filter.SiteId = null;
      this.Clients = [];
      this.Sites = [];
    }
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'UserType': 'A',
      'BranchId': this.Filter.BranchId,
      'ClientId': this.Filter.ClientId,
      'SiteId': this.Filter.SiteId,
      'EmpType': 'front',
      'EmpCode': this.Filter.EmpCode,
      'EmpName': this.Filter.EmpName
    }).subscribe({
      next: (response) => {
        if (response.ComboLoad) {
          if (Combotype == 'Branch') {
            this.Branchs = response.ComboLoad;
          } else if (Combotype == 'Client') {
            this.Clients = response.ComboLoad;
          } else if (Combotype == 'Site') {
            this.Sites = response.ComboLoad;
          } else if (Combotype == 'FilterOnEmpCodeName') {
            this.TableDatas = response.ComboLoad;
            this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
              dtInstance.destroy();
              this.dtTrigger.next(null);
            });
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  onDoubleClick(data: any){
    this.activeModal.close(data);
  }

  close(){
    this.activeModal.close()
  }
}
